var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Down 2 - 1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M13.5841 9.01792L18.8581 17.5781C18.9756 17.7698 18.9643 18.0152 18.8256 18.1947C18.1993 19.008 17.5643 19.7346 17.0305 20.2194C17.0305 20.2194 16.603 20.637 16.3317 20.8177C15.9617 21.1096 15.4779 21.25 15.0079 21.25C14.4803 21.25 13.9816 21.0961 13.5828 20.7896C13.5116 20.72 13.1978 20.455 12.9415 20.2047C11.3464 18.7442 8.71131 14.9319 7.91252 12.9268C7.78376 12.6349 7.515 11.8558 7.5 11.4516C7.5 11.0621 7.585 10.686 7.77126 10.3245C8.02753 9.88004 8.42505 9.53201 8.89632 9.33663C9.22384 9.21086 10.2064 9.0167 10.2351 9.0167C10.9364 8.89092 11.9215 8.79689 13.0715 8.75049C13.2778 8.74194 13.4778 8.84574 13.5841 9.01792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    opacity: 0.4,
    d: "M16.4246 9.59041C16.1908 9.21308 16.4896 8.73806 16.9384 8.75637C17.9909 8.80156 18.9185 8.87971 19.6085 8.97496C19.6235 8.98961 20.8473 9.18377 21.2611 9.40724C22.0299 9.79678 22.4999 10.5612 22.4999 11.383V11.4514C22.4861 11.9814 22.0161 13.1085 21.9874 13.1085C21.7511 13.6763 21.3511 14.4175 20.8698 15.2149C20.6523 15.574 20.1185 15.5825 19.8973 15.2235L16.4246 9.59041Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.bf5795151d844126289b0a8fdf52ff0a.svg";
export { ForwardRef as ReactComponent };